import { TONE } from './constants'
import { getQuickWinCopy } from './reportCopy'

const EFFORT_TAG = {
  low: { labelId: 'AI_RISK_REPORT.EFFORT.LOW', tone: TONE.NEUTRAL },
  medium: { labelId: 'AI_RISK_REPORT.EFFORT.MEDIUM', tone: TONE.NEUTRAL },
  high: { labelId: 'AI_RISK_REPORT.EFFORT.HIGH', tone: TONE.NEUTRAL },
}

const SECTION_TAG = {
  deployment: { labelId: 'AI_RISK_REPORT.SECTION.DEPLOYMENT.TITLE', tone: TONE.NEUTRAL },
  dataExposure: { labelId: 'AI_RISK_REPORT.SECTION.DATA_EXPOSURE.TITLE', tone: TONE.NEUTRAL },
  identity: { labelId: 'AI_RISK_REPORT.SECTION.IDENTITY.TITLE', tone: TONE.NEUTRAL },
  thirdParty: { labelId: 'AI_RISK_REPORT.SECTION.THIRD_PARTY.TITLE', tone: TONE.NEUTRAL },
}

const SECTION_DATA_KEYS = {
  dataExposure: new Set([
    'sharepoint_tenant_settings',
    'groups',
    'group_owners',
    'dynamic_group_guest_inclusion',
    'guest_users',
  ]),
  identity: new Set([
    'global_admin_members',
    'ca_policies',
    'mfa_registration',
    'risky_users',
    'mailbox_forwarding_rules',
  ]),
  thirdParty: new Set([
    'app_registration',
    'enterprise_apps',
    'app_role_assignments',
    'oauth2_grants',
    'authorization_policy',
  ]),
  deployment: new Set(['licenses', 'copilot_licensed', 'copilot_licensed_users']),
}

const quickWinBelongsToSection = ({ quickWin, findingsById, sectionKey }) => {
  const sectionDataKeys = SECTION_DATA_KEYS[sectionKey]
  return (quickWin.sourceFindingIds || []).some((findingId) => {
    const finding = findingsById[findingId]
    return (finding?.sourceDataKeys || []).some((dataKey) => sectionDataKeys.has(dataKey))
  })
}

export const buildSectionRecommendations = ({ intl, quickWins = [], findings = [], sectionKey }) => {
  const findingsById = Object.fromEntries(findings.map((finding) => [finding.id, finding]))

  return quickWins
    .filter((quickWin) => quickWinBelongsToSection({ quickWin, findingsById, sectionKey }))
    .slice()
    .sort((first, second) => first.rank - second.rank)
    .map((quickWin) => {
      const copy = getQuickWinCopy(intl, quickWin.id)
      return {
        key: quickWin.id,
        title: copy.title,
        description: copy.description,
        tags: [SECTION_TAG[sectionKey], EFFORT_TAG[quickWin.effort] ?? EFFORT_TAG.medium].filter(Boolean),
      }
    })
}

export const buildAllRecommendations = ({ intl, quickWins = [], findings = [] }) => [
  ...buildSectionRecommendations({ intl, quickWins, findings, sectionKey: 'deployment' }),
  ...buildSectionRecommendations({ intl, quickWins, findings, sectionKey: 'dataExposure' }),
  ...buildSectionRecommendations({ intl, quickWins, findings, sectionKey: 'identity' }),
  ...buildSectionRecommendations({ intl, quickWins, findings, sectionKey: 'thirdParty' }),
]
